import React, { useCallback, useRef } from 'react';
import type { CustomFilterProps } from 'ag-grid-react';
import { useGridFilter } from 'ag-grid-react';
import { FILTER_STYLES } from '../AgGridCompliance.config';

type TrainingColumnFilterModel = {
  filterType: 'trainingColumn';
  filterValues: { trainingStatus: string };
} | null;

const TRAINING_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'current', label: 'Current' },
  { value: 'missing', label: 'Missing' },
] as const;

export const TrainingColumnFilter = ({
  model,
  onModelChange,
}: CustomFilterProps<any, any, TrainingColumnFilterModel>) => {
  const refFirst = useRef<HTMLSelectElement>(null);
  const value = model?.filterValues?.trainingStatus || 'all';

  const doesFilterPass = useCallback(() => true, []);
  const afterGuiAttached = useCallback(() => {
    refFirst.current?.focus();
  }, []);
  useGridFilter({ doesFilterPass, afterGuiAttached });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const v = e.target.value;
    if (v === 'all') {
      onModelChange(null);
      return;
    }
    onModelChange({
      filterType: 'trainingColumn',
      filterValues: { trainingStatus: v },
    });
  };

  const handleReset = () => onModelChange(null);

  const handleFocus = (e: React.FocusEvent<HTMLSelectElement | HTMLButtonElement>) => {
    e.currentTarget.style.border = FILTER_STYLES.focusBorder;
  };

  const handleBlur = (e: React.FocusEvent<HTMLSelectElement | HTMLButtonElement>) => {
    e.currentTarget.style.border = FILTER_STYLES.defaultBorder;
  };

  return (
    <div style={FILTER_STYLES.container}>
      <div style={FILTER_STYLES.section}>
        <h4 style={FILTER_STYLES.sectionHeading}>Training</h4>
        <div style={FILTER_STYLES.fieldGroup}>
          <label style={FILTER_STYLES.label}>Training status:</label>
          <select
            ref={refFirst}
            style={FILTER_STYLES.select}
            value={value}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          >
            {TRAINING_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div style={FILTER_STYLES.resetButtonContainer}>
        <button type="button" style={FILTER_STYLES.resetButton} onClick={handleReset} onFocus={handleFocus} onBlur={handleBlur}>
          Reset All
        </button>
      </div>
    </div>
  );
};

export default TrainingColumnFilter;
